import * as React from "react";

import { useAppSelector } from "~/state/hooks";
import { getIsDarkMode } from "~/state/settings";

import { Title, Description, LogoHeader, Subtitle } from "./styles";
import { messages } from "./intl";

interface Props {
  isLogin?: boolean;
  title?: MessageDescriptor;
}

export const KidminHeader = ({ isLogin, title }: Props) => {
  const isDarkMode = useAppSelector(getIsDarkMode);

  const logosLight = require("./logos.png");
  const logosDark = require("./logos-dark.png");
  const logos = isDarkMode ? logosDark : logosLight;

  return (
    <>
      <Title>{title || messages.kidminHeaderTitle}</Title>
      <Description>{messages.kidminHeaderDescription}</Description>
      <LogoHeader source={logos} resizeMode="contain" />
      {isLogin ? <Subtitle>{messages.kidminHeaderSubtitle}</Subtitle> : null}
    </>
  );
};
